<template>
  <div class="share">
    <p class="tbc-bold flex-center font-16">{{title}}:</p>

    <a href="">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20.234"
        height="20.234"
        viewBox="0 0 20.234 20.234"
      >
        <path
          id="facebook-square-brands"
          d="M18.066,32H2.168A2.168,2.168,0,0,0,0,34.168v15.9a2.168,2.168,0,0,0,2.168,2.168h6.2V45.355H5.522V42.117H8.367V39.649c0-2.807,1.671-4.358,4.231-4.358a17.238,17.238,0,0,1,2.508.219v2.755H13.693a1.619,1.619,0,0,0-1.826,1.749v2.1h3.107l-.5,3.238h-2.61v6.879h6.2a2.168,2.168,0,0,0,2.168-2.168v-15.9A2.168,2.168,0,0,0,18.066,32Z"
          transform="translate(0 -32)"
          fill="#7d8a98"
        />
      </svg>
    </a>
    <a href="">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20.217"
        height="20.217"
        viewBox="0 0 20.217 20.217"
      >
        <path
          id="Subtraction_111"
          data-name="Subtraction 111"
          d="M11540.888,16831.219h-9.56a5.413,5.413,0,0,1-5.326-5.445v-9.332a5.4,5.4,0,0,1,5.326-5.439h9.56a5.412,5.412,0,0,1,5.331,5.439v9.332A5.422,5.422,0,0,1,11540.888,16831.219Zm-10.956-5.674h0a8.121,8.121,0,0,0,4.414,1.293,7.783,7.783,0,0,0,4.676-1.42,8.6,8.6,0,0,0,3.5-6.758c0-.123,0-.25-.008-.371a6.082,6.082,0,0,0,1.44-1.488,5.755,5.755,0,0,1-1.656.443,2.85,2.85,0,0,0,1.268-1.584,5.717,5.717,0,0,1-1.825.7,2.879,2.879,0,0,0-4.976,1.967,3.464,3.464,0,0,0,.071.658,8.172,8.172,0,0,1-5.922-3.008,2.877,2.877,0,0,0,.887,3.844,2.853,2.853,0,0,1-1.3-.363v.035a2.869,2.869,0,0,0,2.3,2.82,2.938,2.938,0,0,1-.756.1,2.976,2.976,0,0,1-.541-.047,2.874,2.874,0,0,0,2.687,1.994,5.74,5.74,0,0,1-3.569,1.23A5.586,5.586,0,0,1,11529.932,16825.545Z"
          transform="translate(-11526.002 -16811.002)"
          fill="#7d8a98"
        />
      </svg>
    </a>
    <a href="">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20.217"
        height="20.217"
        viewBox="0 0 20.217 20.217"
      >
        <path
          id="Subtraction_110"
          data-name="Subtraction 110"
          d="M11540.888,16831.219h-9.56a5.413,5.413,0,0,1-5.326-5.445v-9.332a5.4,5.4,0,0,1,5.326-5.439h9.56a5.412,5.412,0,0,1,5.331,5.439v9.332A5.422,5.422,0,0,1,11540.888,16831.219Zm-1.952-10.721c1.259,0,1.259,1.193,1.259,2.064v3.8h2.421v-4.289c0-1.928-.352-3.709-2.9-3.709a2.547,2.547,0,0,0-2.289,1.26h-.038v-1.064h-2.323v7.8h2.42v-3.861C11537.482,16821.51,11537.655,16820.5,11538.936,16820.5Zm-7.814-1.939h0v7.8h2.425v-7.8Zm1.213-3.887a1.411,1.411,0,1,0,1.4,1.406A1.406,1.406,0,0,0,11532.334,16814.672Z"
          transform="translate(-11526.002 -16811.002)"
          fill="#7d8a98"
        />
      </svg>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Share Events'
    }
  }
}
</script>

<style scoped>
.share {
  color: var(--svg-fill);
  display: flex;
  padding-bottom: 31px;
  border-bottom: 2px solid rgba(1, 4, 7, 0.05);
}
.share svg {
  margin-left: 15px;
}
.share svg path{
  transition: .3s ease;
}
.share a:hover svg path{
  fill: var(--tbc-blue);
}
.share p {
  color: #7D8A98;
}
</style>
